import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class Utils {
  isNegativeValue = value => {
    return value < 0;
  };
}
